/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { object, string } from 'prop-types';
import React from 'react';

import { Dollar, Percent } from 'components/shared/Text/Text';

export const AllocationChartBar = ({
  allocation,
  barClass,
  barStyle,
  headingClass,
  valuesClass
}) => (
  <div className={'allocation-chart-bar ' + barClass} style={barStyle}>
    <div className={'allocation-chart-heading ' + headingClass}>
      {allocation.label}
    </div>
    <div className={'allocation-chart-values ' + valuesClass}>
      <Dollar element="div" className="allocation-chart-aggregate-value">
        {allocation.aggregate}
      </Dollar>
      <Percent element="div">{allocation.percent}</Percent>
    </div>
  </div>
);

AllocationChartBar.propTypes = {
  allocation: object,
  barClass: string,
  barStyle: object,
  headingClass: string,
  valuesClass: string
};
